import "../styles/DashboardGrid.css";
import SalesByDateChart from "./Charts/SalesByDateChart";
import SalesByCategoryChart from "./Charts/SalesByCategoryChart";
import PurchaseByCategoryChart from "./Charts/PurchaseByCategoryChart";
import PurchaseByDateChart from "./Charts/PurchaseByDateChart";
import TopProductsChart from "./Charts/TopProductsChart";
import TopCategoriesChart from "./Charts/TopCategoriesChart";

const chartCardStyle = {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    padding: "18px 12px",
    minHeight: "260px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
};
const chartTitleStyle = {
    marginBottom: "12px",
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#3a3a3a",
};

const Dashboard = ({
                       kpiTiles,
                       selectedDate,
                       setSelectedDate,
                       selectedKpi,
                       headers,
                   }) => {
    const metricConfigs = [
        {
            key: "sales",
            label: "Total Sales",
            img: "/images/kpi-sales.svg",
            bg: "#E3F0FF",
        },
        {
            key: "purchases",
            label: "Total Purchases",
            img: "/images/kpi-profit.svg",
            bg: "#E7FFF9",
        },
        {
            key: "expenses",
            label: "Total Expenses",
            img: "/images/kpi-expenses.svg",
            bg: "#FFE7E7",
        },
        {
            key: "stock",
            label: "Stock Value",
            img: "/images/kpi-stock.svg",
            bg: "#E7FFF3",
        },
    ];

    // Set the selected date to the most recent kpi tile date on initial load
    if (kpiTiles && kpiTiles.length > 0) {
        const sortedDates = kpiTiles
            .filter((t) => t.kpi_date)
            .map((t) => t.kpi_date)
            .sort((a, b) => b.localeCompare(a));

        console.log("Setting initial selected date to:", sortedDates[0]);
        setSelectedDate(sortedDates[0]);
    }

    let prevValues = {};
    if (kpiTiles && selectedDate) {
        const sortable = kpiTiles
            .filter((t) => t.kpi_date)
            .slice()
            .sort((a, b) => a.kpi_date.localeCompare(b.kpi_date));
        const idx = sortable.findIndex((t) => t.kpi_date === selectedDate);
        const prev = idx > 0 ? sortable[idx - 1] : null;
        if (prev) {
            prevValues =
                typeof prev.tiles === "string"
                    ? JSON.parse(prev.tiles)
                    : prev.tiles || {};
        }
    }
    const computeChange = (curr, prevVal) => {
        if (curr == null || prevVal == null || prevVal === 0) return null;
        const diff = curr - prevVal;
        const pct = (diff / prevVal) * 100;
        return {
            pct: Math.abs(Math.round(pct)),
            trend: diff >= 0 ? "increase" : "decrease",
        };
    };

    const formatValue = (value, key) => {
        if (value == null) return "—";
        if (key === "stock") {
            return Number(value).toLocaleString();
        }
        return `$${Number(value).toLocaleString()}`;
    };

    return (
        <div>
            <h2>Dashboard</h2>
            <div className="kpi-widget-row">
                {selectedKpi ? (
                    metricConfigs.map((m) => {
                        const val = selectedKpi.tiles?.[m.key];
                        const ch = computeChange(val, prevValues[m.key]);
                        return (
                            <div key={m.key} className="kpi-widget">
                                <div className="kpi-left">
                                    <span className="kpi-widget-label">{m.label}</span>
                                    <span className="kpi-widget-value">
                    {formatValue(val, m.key)}
                  </span>
                                    <div className="kpi-widget-divider"/>
                                    {ch ? (
                                        <span className={`kpi-widget-change ${ch.trend}`}>
                      {String(ch.pct).padStart(2, "0")}%{" "}
                                            {ch.trend === "increase" ? "Increase" : "Decrease"}
                    </span>
                                    ) : (
                                        <span
                                            className="kpi-widget-change"
                                            style={{opacity: 0.5}}
                                        >
                      0% Change
                    </span>
                                    )}
                                </div>
                                <div className="kpi-right" aria-hidden>
                                    <div
                                        style={{
                                            width: 56,
                                            height: 56,
                                            borderRadius: 14,
                                            background: m.bg,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            src={m.img}
                                            alt={m.label}
                                            className="kpi-widget-img"
                                            style={{maxHeight: "48px", maxWidth: "48px"}}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p>No KPI tile found for selected date.</p>
                )}
            </div>

            <div
                className="dashboard-charts-grid"
                style={{
                    marginTop: 32,
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "32px 24px",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                <div
                    className="dashboard-chart-section full-width-chart"
                    style={chartCardStyle}
                >
                    <h4 style={chartTitleStyle}>Sales by Date</h4>
                    <SalesByDateChart headers={headers}/>
                </div>
                <div className="dashboard-chart-section" style={chartCardStyle}>
                    <h4 style={chartTitleStyle}>Sales by Category</h4>
                    <SalesByCategoryChart headers={headers}/>
                </div>
                <div className="dashboard-chart-section" style={chartCardStyle}>
                    <h4 style={chartTitleStyle}>Expenses</h4>
                    <PurchaseByCategoryChart headers={headers}/>
                </div>
                <div className="dashboard-chart-section" style={chartCardStyle}>
                    <h4 style={chartTitleStyle}>Top Products</h4>
                    <TopProductsChart headers={headers}/>
                </div>
                <div className="dashboard-chart-section" style={chartCardStyle}>
                    <h4 style={chartTitleStyle}>Top Categories</h4>
                    <TopCategoriesChart headers={headers}/>
                </div>
                <div className="dashboard-chart-section full-width-chart" style={chartCardStyle}>
                    <h4 style={chartTitleStyle}>Purchase by Date</h4>
                    <PurchaseByDateChart headers={headers}/>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
